const types = {
    SAVE_PARAMS: 'DEPARTMENT/SAVE_PARAMS',
    SAVE_SEARCH_PARAMS: 'DEPARTMENT/SAVE_SEARCH_PARAMS',
};

export const saveParams = params => ({
    type: types.SAVE_PARAMS,
    params,
});

export const saveSearchParams = params => ({
    type: types.SAVE_SEARCH_PARAMS,
    params,
});

const initState = {
    feedBack: false,    //返回状态：是否接受store中的查询参数
    params: {},
    pagination: {},
    searchParams: {},
};

const reducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_PARAMS:
            return {
                ...state,
                ...actions.params,
            };
        case types.SAVE_SEARCH_PARAMS:
            return {
                ...state,
                ...actions.params,
            };
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/actions/departmentActions.js